declare global {
    interface RouterMeta {
        title: string;
        keepAlive?:Boolean
    }
    interface Router {
        path: string;
        name: string;
        icon?: string;
        permission?: string;
        meta?: RouterMeta;
        component: any;
        children?: Array<Router>;
    }
    interface System { 
        import(request: string): Promise<any>
    }
    var System: System
}
import login from '../views/login.vue'
import home from '../views/home/home.vue'
import main from '../views/main.vue'

export const locking = {
    path: '/locking',
    name: 'locking',
    component: () => import('../components/lockscreen/components/locking-page.vue')
};
export const loginRouter: Router = {
    path: '/',
    name: 'login',
    meta: {
        title: 'LogIn'
    },
    component: () => import('../views/login.vue')
};
export const registerRouter: Router = {
    path: '/register',
    name: 'register',
    meta: {
        title: '商户注册'
    },
    component: () => import('../views/register.vue')
};
export const otherRouters: Router = {
    path: '/main',
    name: 'main',
    permission: '',
    meta: { title: 'ManageMenu' },
    component: main,
    children: [
        { path: 'home', meta: { title: 'HomePage' }, name: 'home', component: () => import('../views/home/home.vue') }
    ]
}
export const apidocRouters: Router = {
    path: '/publicapidoc',
    name: 'publicapidoc',
    meta: {
        title: 'api对接文档'
    },
    component: () => import('../views/publicapidoc.vue')
}
export const appRouters: Array<Router> = [
    {
    path: "/setting",
        name: "setting",
        meta: { title: "商户模块" },
        icon: "&#xe68a;",
        component: main,
        children: [ 
            { path:"Home",meta:{title:"主页",keepAlive:true},name:"Home",component:()=>import("../views/setting/Home/Home.vue")},
            { path: "myinfo", meta: { title: "个人信息",keepAlive: true  }, name: "myinfo", component: () => import("../views/setting/myinfo/myinfo.vue") },
            { path: "LoginWhiteList",meta:{title:"登录白名单",keepAlive:true},name:"LoginWhiteList",component:()=>import("../views/setting/LoginWhiteList/LoginWhiteList.vue")},
            { path: "apidoc", meta: { title: "API对接",keepAlive: true  }, name: "apidoc", component: () => import("../views/setting/apidoc/apidoc.vue") },
            { path: "updateloginpwd", meta: { title: "修改登录密码",keepAlive: true  }, name: "updateloginpwd", component: () => import("../views/setting/updateloginpwd/updateloginpwd.vue") },
            { path: "updatepaypwd", meta: { title: "修改支付密码",keepAlive: true  }, name: "updatepaypwd", component: () => import("../views/setting/updatepaypwd/updatepaypwd.vue") },
            { path: "Orders", meta: { title: "支付订单",keepAlive: true  }, name: "Orders", component: () => import("../views/setting/OrderManage/Orders/Orders.vue") },
            { path: "RevAccount", meta: { title: "收款账号",keepAlive: true  }, name: "RevAccount", component: () => import("../views/setting/RevAccount/RevAccount.vue") },
            { path: "withdraw", meta: { title: "申请提现",keepAlive: true  }, name: "withdraw", component: () => import("../views/setting/withdraw/withdraw.vue") },
            { path: "products", meta: { title: "支付通道",keepAlive: true  }, name: "products", component: () => import("../views/setting/products/products.vue") },
            { path: "MerchantBalanceLogs", meta: { title: "余额变动",keepAlive: true  }, name: "MerchantBalanceLogs", component: () => import("../views/setting/MerchantBalanceLogs/MerchantBalanceLogs.vue") },
            { path: "AdvanceMoneys", meta: { title: "预付变动",keepAlive: true  }, name: "AdvanceMoneys", component: () => import("../views/setting/AdvanceMoneys/AdvanceMoneys.vue") },
            { path: "DayBills", meta: { title: "日终统计",keepAlive: true  }, name: "DayBills", component: () => import("../views/setting/DayBills/DayBills.vue") },
            { path: "RealBalanceLogs", meta: { title: "账变记录",keepAlive: true  }, name: "RealBalanceLogs", component: () => import("../views/setting/RealBalanceLogs/RealBalanceLogs.vue") },
            
            // { path: "testpayorder", meta: { title: "测试拉取订单",keepAlive: true  }, name: "testpayorder", component: () => import("../views/setting/testpayorder/testpayorder.vue") },
        ], 
}
 
] 
export const routers = [
    loginRouter,
    registerRouter,
    locking,
    ...appRouters,
    otherRouters,
    apidocRouters
];
